import { ProjectSchedules as ProjectSchedulesIcon } from "./../../Components/Icon";
import { navigationMapBuilder } from "./helpers";
import Submit from "./../../Pages/Submit";

const navigation = () => ([
  {
    header: "Submit",
    links: [
      {
        text: "Submit",
        icon: ProjectSchedulesIcon,
        route: "submit",
        component: Submit,
        stage:"preProposal"
      },
    ],
  },
]);

const navigationMap = (parentRoute) =>
  navigationMapBuilder(parentRoute, navigation);

export default navigationMap;
